<!-- Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com -->
<!-- See license file. -->
<script setup lang="ts">
import { inject } from "vue";
import { actorsKey } from "@/logic/provide";
import ActorList from "@/components/actors/ActorList.vue";
import NavigationManager from "@/components/navigation/NavigationManager.vue";
import Navigation from "@/components/navigation/Navigation.vue";

const actors = inject(actorsKey);
</script>

<template>
  <div v-if="!actors || actors.list.length === 0"></div>
  <NavigationManager v-else>
    <Navigation navKey="Base des requérants">
      <ActorList />
    </Navigation>
  </NavigationManager>
</template>
<style lang="scss"></style>
